<odl-button
  id="tts-mobile-more-actions"
  [description]="'NAVIGATION.BOOKMARKS.MORE_ACTIONS' | translate"
>
  <odl-icon name="more_vert" slot="only-icon"></odl-icon>
</odl-button>
<odl-tooltip for="#tts-mobile-more-actions">
  {{ 'NAVIGATION.BOOKMARKS.MORE_ACTIONS' | translate }}
</odl-tooltip>

<odl-menu for="#tts-mobile-more-actions">
  <odl-menu-item>
    <odl-icon name="speed" slot="icon"></odl-icon>
    <span>{{ 'TTS.PLAYBACK_SPEED' | translate }}</span>

    <ng-content select="[slot='rate-submenu']"></ng-content>
  </odl-menu-item>

  <odl-menu-item>
    <odl-icon name="voice" slot="icon"></odl-icon>
    <span>{{ 'TTS.VOICE' | translate }}</span>

    <ng-content select="[slot='voice-submenu']"></ng-content>
  </odl-menu-item>
</odl-menu>
